<template>
  <title-card title="Summary">
    <b-col md="12" lg="6" xl="6" class="mb-1 mt-9">
      <b-row class="mb-1 mt-5">
        <b-col class="label ml-5 text-right"><strong>Loan #: </strong></b-col>
        <b-col> {{ loan.number }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label ml-5 text-right"> Address:</b-col>
        <b-col> {{ loan.property.address }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label ml-5 text-right"> City:</b-col>
        <b-col> {{ loan.property.city }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label ml-5 text-right"> State, Zip:</b-col>
        <b-col> {{ loan.property.state }}, {{ loan.property.zip_code }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label ml-5 text-right"> Entity:</b-col>
        <b-col>
          <a href="#" @click="entityClicked(entity)">
            {{ entityName }}
          </a>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label ml-5 text-right"> Loan Type:</b-col>
        <b-col class="capitalize"> {{ loan.transaction_type }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label ml-5 text-right"> Loan Amount:</b-col>
        <b-col> {{ loan.amount | currency }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label ml-5 text-right"> Status:</b-col>
        <b-col> {{ loan.loan_category | category}}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label ml-5 text-right"> Appraisal:</b-col>
        <b-col> {{ appraisal }}</b-col>
      </b-row>
    </b-col>
  </title-card>
</template>

<script>
import TitleCard from '@/components/utils/TitleCard';
import CategoryPresentation from '@/components/my_deals/resources/CategoryPresentation.json';

export default {
  components: {
    TitleCard,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
    entity: Object,
  },
  computed: {
    entityName() {
      if (this.entity) {
        return this.entity.name;
      }
      return '';
    },
    appraisal() {
      const appraisal = Array.isArray(this.loan.appraisal) && this.loan.appraisal.length > 0 ?
        this.loan.appraisal[0] :
        null;

      if (appraisal === null || (appraisal.appraisal_received === null &&
        appraisal.appraisal_ordered === null)) {
        return 'Not ordered';
      }
      const hasAppraisal = 'appraisal_received' in appraisal && 'appraisal_ordered' in appraisal;

      if (!hasAppraisal) {
        return 'Not ordered';
      }
      if (appraisal.appraisal_received !== null) {
        return 'Received';
      }
      if (appraisal.appraisal_ordered !== null) {
        return 'Ordered';
      }

      return '-';
    },
  },
  methods: {
    entityClicked(entity) {
      if (this.entity) {
        this.$router.push({ name: 'EntityDetails', params: { id: entity.id } });
      }
    },
  },
  filters: {
    category(value) {
      if (value === null) return '';
      const category = CategoryPresentation[value];
      if (category) {
        return category;
      }

      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>

<style scoped>
.label {
  font-weight: bolder;
}
.capitalize {
  text-transform: capitalize;
}

.mb-1, .my-1 {
  margin-bottom: 1.25rem !important;
}
@media (min-width: 1333px) {
  .raised.p-3.rounded.mt-sm-3 {
    height: 98% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_deals/deals/LoanPendingAttributes.vue